module.exports = __webpack_public_path__ + "img/martinvidaurre.d26a56a4.jpg";